import makeRequest from "@/api/makeRequest";
import { IExaminationDataValue } from "@/models/ExaminationDataValue";
import normalizeExaminationValueDate from "@/utils/normalizeExaminationValueDate";

const ExaminationDataApi = {
  getExaminationData: async (
    examId: number,
    period: 10 | 60 = 60
  ): Promise<IExaminationDataValue[]> => {
    const { data } = await makeRequest<IExaminationDataValue[]>({
      url: `/examination-data/${examId}/${period}`,
    });
    return data.map(normalizeExaminationValueDate);
  },
};

export default ExaminationDataApi;
